/* Pure C84 selector. Browser global + CommonJS; no DOM/network/cart writes. */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports) module.exports=api;
  else root.MiniamiRecommendations=api;
})(typeof globalThis==='object'?globalThis:this,function(){
  'use strict';
  const role='standalone-digital-pattern';
  const validId=id=>typeof id==='string'&&/^[1-9][0-9]*$/.test(id);
  const cmpId=(a,b)=>a.length-b.length||(a<b?-1:a>b?1:0);
  const count=n=>Number.isSafeInteger(n)&&n>=0;
  function select(snapshot,cartProductIds,currentCandidates,limit=3){
    if(!snapshot||snapshot.schema!=='miniami-c84-v1'||!count(snapshot.basket_count)||snapshot.basket_count===0||
      !snapshot.policy||snapshot.policy.alpha!==5||snapshot.policy.minimum_pair_orders!==2||
      !Array.isArray(snapshot.products)||!Array.isArray(snapshot.pairs)||!Array.isArray(cartProductIds)||
      !cartProductIds.every(validId)||!Array.isArray(currentCandidates)||!Number.isSafeInteger(limit)||limit<0) return [];
    const products=new Map(),pairMap=new Map();
    for(const p of snapshot.products){
      if(!p||!validId(p.id)||products.has(p.id)||p.role!==role||typeof p.handle!=='string'||!p.handle||
        !count(p.order_count)||p.order_count>snapshot.basket_count) return [];
      products.set(p.id,p);
    }
    for(const pair of snapshot.pairs){
      if(!Array.isArray(pair)||pair.length!==3) return [];
      const [a,b,n]=pair,pa=products.get(a),pb=products.get(b),key=a+':'+b;
      if(!pa||!pb||cmpId(a,b)>=0||!count(n)||n<2||n>pa.order_count||n>pb.order_count||pairMap.has(key)) return [];
      pairMap.set(key,n);
    }
    const pairCount=(a,b)=>pairMap.get(cmpId(a,b)<0?a+':'+b:b+':'+a)||0;
    const excluded=new Set(cartProductIds);
    const seeds=[...excluded].filter(id=>products.has(id)&&products.get(id).order_count>0).sort(cmpId);
    const rows=[],seen=new Set();
    for(const c of currentCandidates){
      if(!c||!validId(c.id)||seen.has(c.id)) return [];
      seen.add(c.id);
      const p=products.get(c.id);
      if(!p||excluded.has(c.id)||c.available!==true||c.role!==role||c.handle!==p.handle) continue;
      const popularity=p.order_count/snapshot.basket_count;
      const evidence=seeds.map(id=>({id,n:pairCount(id,p.id)}));
      const support=evidence.reduce((n,e)=>n+e.n,0);
      const matched=evidence.filter(e=>e.n>0);
      const score=matched.length?evidence.reduce((n,e)=>n+(e.n+5*popularity)/(products.get(e.id).order_count+5),0)/seeds.length:popularity;
      rows.push({id:p.id,handle:p.handle,score,reason:matched.length?'copurchase':'popularity',
                 pair_support: support,order_count:p.order_count,matched_cart_ids:matched.map(e=>e.id)});
    }
    rows.sort((a,b)=>(a.reason==='copurchase'?0:1)-(b.reason==='copurchase'?0:1)||b.score-a.score||
      b.pair_support-a.pair_support||b.order_count-a.order_count||cmpId(a.id,b.id));
    return rows.slice(0,Math.min(limit,12));
  }
  // Pure freshness wrapper: clock is supplied by the caller, not read here.
  // Twice-daily updates: allow the 16h gap plus 2h grace (17h plus 1h at DST fall).
  function selectCurrent(snapshot,cartProductIds,currentCandidates,limit,nowMs){
    const end=Date.parse(snapshot&&snapshot.window&&snapshot.window.end_exclusive);
    if(!Number.isFinite(nowMs)||!Number.isFinite(end)||nowMs<end||nowMs-end>18*60*60*1000) return [];
    return select(snapshot,cartProductIds,currentCandidates,limit);
  }
  return Object.freeze({select,selectCurrent});
});
